import reportClientError from "./clientTelemetry";

function mapsApi() {
  if (!window.google?.maps) throw new Error("Google Maps is still loading");
  return window.google.maps;
}

function runGeocode(request) {
  const geocoder = new (mapsApi().Geocoder)();
  return new Promise((resolve, reject) => {
    geocoder.geocode(request, (results, status) => {
      if (status === "OK" && results?.length) resolve(results);
      else reject(new Error(`Address lookup failed (${status || "UNKNOWN"})`));
    });
  });
}

export function geocodeAddress(address) {
  return runGeocode({ address });
}

export function reverseGeocode(lat, lng) {
  return runGeocode({ location: { lat: Number(lat), lng: Number(lng) } });
}

export function latLngFromGeocode(result) {
  const location = result?.geometry?.location;
  if (!location) throw new Error("Address lookup returned no coordinates");
  return {
    lat: typeof location.lat === "function" ? location.lat() : Number(location.lat),
    lng: typeof location.lng === "function" ? location.lng() : Number(location.lng),
  };
}

export async function getPlaceSummary(placeId, fallbackName = "") {
  const places = mapsApi().places;

  if (places?.Place) {
    try {
      const place = new places.Place({ id: placeId });
      await place.fetchFields({ fields: ["displayName", "formattedAddress"] });
      return {
        name: place.displayName || fallbackName,
        vicinity: place.formattedAddress || "",
      };
    } catch (error) {
      reportClientError(error, { area: "google_places_new_details_fallback" });
    }
  }

  // Compatibility path for deployments whose Maps project has not enabled the
  // new Places API yet. This path can be removed after all environments migrate.
  return new Promise((resolve, reject) => {
    reportClientError("Falling back to legacy Places details", {
      area: "google_places_legacy_fallback",
    });
    const service = new places.PlacesService(document.createElement("div"));
    service.getDetails({ placeId }, (result, status) => {
      if (status === "OK" && result) {
        resolve({ name: result.name || fallbackName, vicinity: result.vicinity || "" });
      } else {
        reject(new Error(`Place details failed (${status || "UNKNOWN"})`));
      }
    });
  });
}
